<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <div class="py-2">
              <Link class="btn btn-outline-success" :href="`/admin/portal/${jenis}`">Kembali</Link>
            </div>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link :href="`/admin/portal/${jenis}`" v-text="jenis_name()"></Link>
                </li>
                <li class="breadcrumb-item">
                  <span>Buat {{jenis_name()}} Baru</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <input type="text" v-model="title" name="judul" id="judul" class="form-control" placeholder="Judul Postingan ...">
                </div>
                <div class="col-auto">
                  <button class="btn btn-outline-secondary" @click="action()">Simpan sebagai Draf</button>
                </div>
                <div class="col-auto">
                  <button class="btn btn-info" @click="action(true)">Publikasi</button>
                </div>
              </div>

              <hr>

              <laraberg-editor v-model="content"/>

            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

</template>

<script>
import Layout from '@/layout/Editor'
import Modal from '@/components/Modal'
import LarabergEditor from '@/components/LarabergEditor'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal, LarabergEditor },
  props: {
    postingan: Object,
    jenis: String
  },
  data() {
    return {
      id: false,
      title: '',
      content: `<!-- wp:paragraph --><p></p><!-- /wp:paragraph -->`,
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    postingan() {
      this.init();
    }
  },
  methods: {
    action(publish = true) {
      const data = {
        title: this.title,
        content: this.content,
        status_postingan: publish ? 'PUBLISHED' : 'DRAF'
      };
      if(this.id) {
        this.$inertia.put('/admin/portal/editor/' + this.jenis + '/' + this.id, data);
      } else {
        this.$inertia.post('/admin/portal/editor/' + this.jenis, data);
      }
    },
    jenis_name() {
      switch(this.jenis) {
        case 'posts': return 'Postingan';
        case 'pages': return 'Artikel';
        default: return '-';
      }
    },
    init() {
      if(this.postingan) {
        const { id, title, content } = this.postingan;
        this.id = id;
        this.title = title;
        this.content = content;
      }
    }
  }
}
</script>
